(() => {
  if (window.__qlsPackageProtectionCheckoutInstalled) return;
  window.__qlsPackageProtectionCheckoutInstalled = true;

  let queued = false;
  let applying = false;

  const moneyMatches = (text) =>
    String(text || '').match(/(?:US\s*)?\$\s*[\d,]+(?:\.\d{2})?/g) || [];

  const moneyValue = (text) => {
    const value = Number(String(text || '').replace(/[^\d.-]/g, ''));
    return Number.isFinite(value) ? value : null;
  };

  const formatUsd = (value) =>
    new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(value);

  function updateContainer(container) {
    const label = container.querySelector('.ssp-checkout-text');
    const primary = container.querySelector('.ssp-checkout-button');
    const secondary = container.querySelector('.ssp-checkout-link');
    if (!label || !primary || !secondary) return;

    // These two spans are created and maintained by Simply Shipping
    // Protection from the app variables ##plan_price## and ##cart_total##.
    const planElement = primary.querySelector('.insurance_plan');
    const cartTotalElement = primary.querySelector('.ssp_cart_total');
    if (!planElement || !cartTotalElement) return;

    const planText = planElement.textContent.trim();
    const planValue = moneyValue(planText);
    const cartValue = moneyValue(cartTotalElement.textContent);
    const combinedTotal =
      planValue !== null && cartValue !== null
        ? formatUsd(planValue + cartValue)
        : cartTotalElement.textContent.trim();
    const secondaryText = 'Checkout without package protection';

    if (!label.querySelector('.qls-pp-label-mark')) {
      label.innerHTML =
        '<span class="qls-pp-label-mark" aria-hidden="true">' +
          '<svg viewBox="0 0 38 30" focusable="false">' +
            '<path class="qls-pp-mark__box" d="M7.5 11 19 5.2 30.5 11 19 16.8 7.5 11Zm0 0v10.7L19 27.2V16.8L7.5 11Zm23 0v10.7L19 27.2V16.8L30.5 11Z"/>' +
            '<path class="qls-pp-mark__tape" d="m13.2 8.1 11.7 5.8v5.2"/>' +
            '<circle class="qls-pp-mark__badge" cx="29.5" cy="7.4" r="6.1"/>' +
            '<path class="qls-pp-mark__check" d="m26.8 7.4 1.8 1.8 3.7-4"/>' +
          '</svg>' +
        '</span>' +
        '<span>Package Protect • ' + planText + '</span>';
    }

    let checkoutLabel = primary.querySelector('.qls-protected-checkout-label');
    let checkoutMark = primary.querySelector('.qls-pp-mark');
    let checkoutTotal = primary.querySelector('.qls-protected-combined-total');

    if (!checkoutLabel || !checkoutMark || !checkoutTotal) {
      // Remove only the app's plain text ("Checkout" and "+"). Its live
      // price spans stay untouched for both display and checkout behavior.
      Array.from(primary.childNodes).forEach((node) => {
        if (node.nodeType === Node.TEXT_NODE) node.remove();
      });

      primary.querySelectorAll(
        '.qls-protected-checkout-price, .qls-protected-price-separator'
      ).forEach((node) => node.remove());

      checkoutLabel = document.createElement('span');
      checkoutLabel.className = 'qls-protected-checkout-label';
      checkoutLabel.textContent = 'Checkout +';

      checkoutMark = document.createElement('span');
      checkoutMark.className = 'qls-pp-mark';
      checkoutMark.setAttribute('aria-hidden', 'true');
      checkoutMark.innerHTML =
        '<svg viewBox="0 0 38 30" focusable="false">' +
          '<path class="qls-pp-mark__box" d="M7.5 11 19 5.2 30.5 11 19 16.8 7.5 11Zm0 0v10.7L19 27.2V16.8L7.5 11Zm23 0v10.7L19 27.2V16.8L30.5 11Z"/>' +
          '<path class="qls-pp-mark__tape" d="m13.2 8.1 11.7 5.8v5.2"/>' +
          '<circle class="qls-pp-mark__badge" cx="29.5" cy="7.4" r="6.1"/>' +
          '<path class="qls-pp-mark__check" d="m26.8 7.4 1.8 1.8 3.7-4"/>' +
        '</svg>';

      checkoutTotal = document.createElement('span');
      checkoutTotal.className = 'qls-protected-combined-total';

      primary.insertBefore(checkoutLabel, primary.firstChild);
      primary.insertBefore(checkoutMark, planElement);
      primary.insertBefore(checkoutTotal, planElement);
    }

    // Keep the app's live values in the DOM for variant resolution and
    // checkout behavior, but present customers with one combined total.
    planElement.style.setProperty('display', 'none', 'important');
    cartTotalElement.style.setProperty('display', 'none', 'important');
    const combinedText = '• ' + combinedTotal;
    if (checkoutTotal.textContent !== combinedText) {
      checkoutTotal.textContent = combinedText;
    }

    primary.style.setProperty('display', 'flex', 'important');
    primary.style.setProperty('align-items', 'center', 'important');
    primary.style.setProperty('justify-content', 'center', 'important');
    primary.style.setProperty('column-gap', '0', 'important');
    checkoutMark.style.setProperty('margin', '0 6px', 'important');

    if (secondary.textContent.trim() !== secondaryText) {
      secondary.textContent = secondaryText;
    }

    const primaryText =
      'Checkout with Package Protect, total ' + combinedTotal;
    if (primary.getAttribute('aria-label') !== primaryText) {
      primary.setAttribute('aria-label', primaryText);
    }
    if (secondary.getAttribute('aria-label') !== secondaryText) {
      secondary.setAttribute('aria-label', secondaryText);
    }
  }

  function apply() {
    queued = false;
    if (applying) return;
    applying = true;
    document.querySelectorAll('.ssp-checkout-button-container').forEach(updateContainer);
    applying = false;
  }

  function schedule() {
    if (queued || applying) return;
    queued = true;
    window.requestAnimationFrame(apply);
  }

  const normalizeAmount = (value) => {
    const amount = Number(String(value ?? '').replace(/[^\d.-]/g, ''));
    return Number.isFinite(amount) ? Math.round(amount * 100) : null;
  };

  function protectionPlans() {
    return window.simplyInsurance?.insurancePlan?.planArray || [];
  }

  function resolveProtectionVariant(primary) {
    const displayedPlan = normalizeAmount(
      primary.querySelector('.insurance_plan')?.textContent
    );
    const plans = protectionPlans().filter((plan) => plan?.variant_id);

    if (displayedPlan !== null) {
      const exact = plans.find(
        (plan) => normalizeAmount(plan.insurance_plan_amount) === displayedPlan
      );
      if (exact) return String(exact.variant_id);
    }

    return plans.length === 1 ? String(plans[0].variant_id) : null;
  }

  async function protectedCheckout(event) {
    const primary = event.target.closest?.('.ssp-checkout-button');
    if (!primary || !primary.closest('.ssp-checkout-button-container')) return;
    if (primary.dataset.qlsCheckoutPending === 'true') {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }

    const variantId = resolveProtectionVariant(primary);
    if (!variantId) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    primary.dataset.qlsCheckoutPending = 'true';
    primary.setAttribute('aria-busy', 'true');

    try {
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-REF': '1'
        },
        body: JSON.stringify({
          updates: { [variantId]: 1 },
          attributes: { 'si-widget-state': '1' }
        })
      });
      if (!response.ok) throw new Error('Protection could not be added');

      const cart = await response.json();
      const added = Array.isArray(cart.items) && cart.items.some(
        (item) => String(item.variant_id) === variantId && item.quantity > 0
      );
      if (!added) throw new Error('Protection was not confirmed in cart');

      window.location.assign('/checkout');
    } catch (error) {
      primary.dataset.qlsCheckoutPending = 'false';
      primary.removeAttribute('aria-busy');
      window.location.assign('/checkout?updates[' + encodeURIComponent(variantId) + ']=1');
    }
  }

  // Capture the click before the app's own malformed checkout URL runs.
  document.addEventListener('click', protectedCheckout, true);

  const observer = new MutationObserver(schedule);
  const start = () => {
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
    schedule();
  };

  if (document.body) start();
  else document.addEventListener('DOMContentLoaded', start, { once: true });

  document.addEventListener('dispatch:cart-drawer:refresh', () => window.setTimeout(schedule, 80));
  document.addEventListener('cart:updated', () => window.setTimeout(schedule, 80));
})();
